/***
 * Created by zhengyf on 2017/12/19.
 */

/**
 * mode: 'large' 展开工具栏 ， 'mini' 收缩工具栏.
 */


;(function () {

    RfqToolbarCtrl.$inject = ['request', '$timeout', 'rfqLoadAccInfoFactory'];
    angular
        .module('DSSXAPP')
        .component('rfqToolbar', {
            template:'<div class="rfq-component rfq-component-toolbar" ng-class="{\'large\': vm.c.layout === \'large\', \'mini\': vm.c.layout === \'mini\'}"><div class="sidebar-menu"><div class="sidebar-toggle" ng-click="vm.f.toggleLayout()"><a href="javascript:;"><i class="next-icon next-icon-small" ng-class="{\'next-icon-arrow-double-right\': vm.c.layout === \'large\', \'next-icon-arrow-double-left\': vm.c.layout === \'mini\'}"></i></a></div><div class="sidebar-list"><a href="javascript:;" target="blank"><div class="item-list item-list-quote"><span></span><div class="item-icon"><span ng-bind="vm.d.quoteEquityNum"></span></div><div class="item-text">可用报价权限</div></div></a> <a href="javascript:;" target="blank"><div class="item-list"><span></span><div class="item-icon"><i class="next-icon next-icon-email next-icon-medium"></i></div><div class="item-text">新消息</div></div></a> <a href="javascript:;" target="blank"><div class="item-list"><span></span><div class="item-icon"><i class="next-icon next-icon-browse next-icon-medium"></i></div><div class="item-text">最近看过</div></div></a> <a href="rfq/quotation-list.html" target="blank"><div class="item-list"><span></span><div class="item-icon"><i class="next-icon next-icon-form next-icon-medium"></i></div><div class="item-text">报价管理</div></div></a> <a href="draft-trusts.html" target="blank"><div class="item-list"><span></span><div class="item-icon"><i class="next-icon next-icon-dollar next-icon-medium"></i></div><div class="item-text">起草信保订单</div></div></a><a href="javascript:;" target="blank"><div class="item-list"><span></span><div class="item-icon"><i class="next-icon next-icon-store next-icon-medium"></i></div><div class="item-text">免费建站</div></div></a> <a href="javascript:;" target="blank"><div class="item-list"><span></span><div class="item-icon"><i class="next-icon next-icon-office next-icon-medium"></i></div><div class="item-text">商家中心</div></div></a></div><div class="sidebar-footer"><a href="//activity.alibaba.com/rfq/81e514cb.html?spm=a2700.8073605.0.0.6151c2b8On5qV5&tracelog=mashang_alisourceprolisthelp" target="_blank"><i class="next-icon next-icon-help next-icon-medium"></i></a> <a href="javascript:;"><div class="phone-code"><i class="next-icon next-icon-mobile-phone next-icon-medium"></i></div></a><div class="sidebar-top" ng-click="vm.f.gotoTop()"><a href="javascript:;"><i class="next-icon next-icon-arrow-up next-icon-medium"></i><div>TOP</div></a></div></div></div><div class="sidebar-panel" ng-show="vm.d.showQuoteInfo"><i class="next-icon next-icon-close next-icon-small" ng-click="vm.f.closeQuoteInfo()"></i><div class="equote-panel"><div class="equote-header"><h3>可用报价权限</h3><span></span><div class="equote-score" ng-bind="vm.d.quoteEquityNum"></div><div><a href="my-equity-detail.html" target="_blank">查看详情</a></div></div><div class="equote-body"><h3>提升市场表现分，获取更多报价权益</h3><div class="equote-item"><div>您当前的市场表现分：<span>0</span>分</div><p><span><a href="//activity.alibaba.com/rfq/f52e8f5f.html?tracelog=form_sidebar" target="_blank">分值解读与提升</a></span></p></div><h3>购买RFQ加油包获取更多报价权益</h3><div class="equote-item"><span>在线购买加油包，获得更多商机。<a href="javascript:;">立即购买</a></span></div></div></div></div></div>',
            bindings: {
                mode: '<'
            },
            controllerAs: 'vm',
            controller: RfqToolbarCtrl
        });

    function RfqToolbarCtrl(request, $timeout, rfqLoadAccInfoFactory) {

        this.$onInit = onInit;
        this.$onChanges = bindingsOnChanges;

        var vm = this;

        vm.c = {
            layout: 'large'
        };

        vm.d = {
            quoteEquityNum: 0,
            showQuoteInfo: false
        };

        vm.f = {
            gotoTop: gotoTop,
            toggleLayout: toggleLayout,
            closeQuoteInfo: closeQuoteInfo
        };

        var bodyElement = $('html,body');
        var util = DSSX.util;
        var sidebarList;

        function onInit() {
            console.log('[RfqToolbarCtrl init: ]');
            rfqLoadAccInfoFactory.start('numQuoteEquity', true)
                .then(function (res) {
                    console.log('[rfqLoadAccInfoFactory toolbar: ]', res);
                    vm.d.quoteEquityNum = res.quoteEquityNum;
                });
            bindingsEvent();
        }

        function bindingsOnChanges(changes) {

            if (changes.mode) {
                vm.c.layout = vm.mode;
            }
        }

        function gotoTop() {
            bodyElement.animate({'scrollTop': 0}, 500);
        }

        function toggleLayout() {
            vm.c.layout = vm.c.layout === 'large' ? 'mini' : 'large';
        }

        // 加载可用报价权益数量
        function loadQuoteEquityNum() {

            return request.get('/usr/api/loadAccInfo', {returnField: 'numQuoteEquity'}, true)
                .then(callback, errCallback);

            function callback(res) {

                vm.d.quoteEquityNum = util.safe(res, 'data.accInfo.numQuoteEquity', 0);
            }

            function errCallback(error) {
                DSSX.dialog.err(error, {
                    moduleName: 'RFQ工具栏',
                    funcName: 'loadQuoteEquityNum',
                    text: '加载可用报价权限失败'
                });
            }

        }

        function bindingsEvent() {

            sidebarList = $('.sidebar-list');

            sidebarList.on('click', '.item-list-quote', handleSidebarClick);
        }

        function handleSidebarClick(e) {

            if (vm.d.showQuoteInfo) {
                removeAllArrow();
                $timeout(function() {
                    vm.d.showQuoteInfo = false;
                });
            } else {
                var ele = $(e.currentTarget);
                removeAllArrow();
                ele.find('>span').addClass('arrow');
                $timeout(function() {
                    vm.d.showQuoteInfo = true;
                });
            }
        }

        function closeQuoteInfo() {
            vm.d.showQuoteInfo = false;
            removeAllArrow();
        }

        function removeAllArrow() {

            var arrowList = $('.sidebar-list .item-list >span');

            for (var i = 0; i < arrowList.length; i++) {
                var ele = arrowList.eq(i);
                ele.removeClass('arrow');
            }
        }

    }

})();